var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingloansicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.65 12.0809C25.1687 12.0118 24.685 11.96 24.2 11.9257M6.79998 14.7242C6.30504 14.6894 5.82171 14.6377 5.34998 14.5691M19.125 13.325C19.125 14.2864 18.7431 15.2084 18.0632 15.8882C17.3834 16.568 16.4614 16.95 15.5 16.95C14.5386 16.95 13.6165 16.568 12.9367 15.8882C12.2569 15.2084 11.875 14.2864 11.875 13.325C11.875 12.3635 12.2569 11.4415 12.9367 10.7617C13.6165 10.0819 14.5386 9.69995 15.5 9.69995C16.4614 9.69995 17.3834 10.0819 18.0632 10.7617C18.7431 11.4415 19.125 12.3635 19.125 13.325Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 24.2C13.5686 25.1019 11.0297 25.65 8.25 25.65C6.7043 25.65 5.234 25.4803 3.9 25.1758C1.725 24.677 1 23.3677 1 21.1347V5.5153C1 4.08705 2.508 3.10685 3.9 3.42585C5.234 3.73035 6.7043 3.9 8.25 3.9C11.0297 3.9 13.5686 3.3519 15.5 2.45C17.4314 1.5481 19.9704 1 22.75 1C24.2957 1 25.766 1.16965 27.1 1.47415C29.3939 2.0005 30 3.349 30 5.5153V21.1347C30 22.5629 28.492 23.5431 27.1 23.2241C25.766 22.9196 24.2957 22.75 22.75 22.75C19.9704 22.75 17.4314 23.2981 15.5 24.2Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingloansicon);
export default __webpack_public_path__ + "static/media/pendingloansicon.fa583d277060e16eb552a40cbbddf0d4.svg";
export { ForwardRef as ReactComponent };